import script from "./StoreGroupWelcomePopup.vue?vue&type=script&setup=true&lang=js"
export * from "./StoreGroupWelcomePopup.vue?vue&type=script&setup=true&lang=js"

import "./StoreGroupWelcomePopup.vue?vue&type=style&index=0&id=af9d77b4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-af9d77b4"]])

export default __exports__